import { render, staticRenderFns } from "./DetailCardDialog.vue?vue&type=template&id=5d9649b8&scoped=true"
import script from "./DetailCardDialog.vue?vue&type=script&lang=js"
export * from "./DetailCardDialog.vue?vue&type=script&lang=js"
import style0 from "./DetailCardDialog.vue?vue&type=style&index=0&id=5d9649b8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9649b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d9649b8')) {
      api.createRecord('5d9649b8', component.options)
    } else {
      api.reload('5d9649b8', component.options)
    }
    module.hot.accept("./DetailCardDialog.vue?vue&type=template&id=5d9649b8&scoped=true", function () {
      api.rerender('5d9649b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/customerOrderPre/components/DetailCardDialog.vue"
export default component.exports